import { useCallback } from 'react';
import { FormApi } from 'final-form';
import { MultiStepFormSteps } from 'src/lib/MultiStepForm/types';
import { TemplateProperty, useTemplateContext } from 'src/lib/templates';
import { useMultiStepFormContext } from 'src/lib/MultiStepForm';
import { useCheckoutFormContext } from './CheckoutFormContext';

interface UseStepSubmitOptions {
  currentStep?: MultiStepFormSteps;
  form?: FormApi<any>;
  template?: TemplateProperty;
}

export const useStepSubmit = (options?: UseStepSubmitOptions) => {
  const contextForm = useCheckoutFormContext().form;
  const { setTemplate } = useTemplateContext();
  const { goToNextStep } = useMultiStepFormContext();

  const form = options?.form || contextForm;
  const stepKey = options?.template?.name || options?.currentStep?.template?.name;

  const handleStepSubmit = useCallback(async () => {
    if (!stepKey) return;

    setTemplate((template) => ({
      ...template,
      template: template.template.filter((field) => field.name === stepKey),
    }));

    await form.submit();

    if (!form.getState().hasValidationErrors) {
      goToNextStep();
    }
  }, [form, stepKey, setTemplate, goToNextStep]);

  return { handleStepSubmit };
};
